import { REPLACEMENTS_KEYS } from './tableKeys';

const { REPLACED, REPLACEMENT } = REPLACEMENTS_KEYS;

export const normalizeReplacementValue = (fieldName, value) => {
  if (typeof value !== 'string') {
    return value;
  }

  if (fieldName === REPLACED) {
    return value.replace(/[A-ZА-ЯЁ]/g, match => match.toLowerCase());
  }

  if (fieldName === REPLACEMENT) {
    return value.toLowerCase();
  }

  return value;
};
